<template>
    <v-row v-if="error" class="mt-12" justify="center">
        <v-col class="mt-12">
            <div class="d-flex justify-center">
                <img width="250" class="home-logo" :src="`/common/img/giglets-logo-grey.png`" alt="Giglets" />
            </div>
            <v-alert class="mb-5" variant="outlined" :text="error" type="error"></v-alert>
        </v-col>
    </v-row>
    <v-overlay :model-value="signInInProgress" class="align-center justify-center">
        <v-progress-circular indeterminate color="brand"></v-progress-circular>
    </v-overlay>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ScopeValues } from '~/shared/scopes';

definePage({
    meta: {
        layout: 'bare',
        noAuth: true,
    },
});

const router = useRouter();
const route = useRoute();
const auth = useAuth();
const { isLoggedIn, scopes, userType } = storeToRefs(auth);

const error = ref('');
const signInInProgress = ref(false);

const basePath = (process.env.VITE_BASE_PATH || '').replace(/\/$/, '');

onMounted(async () => {
    if (isLoggedIn.value) {
        router.push('/staff/home');
    } else if (typeof route.query.code === 'string') {
        signInInProgress.value = true;
        // No await here since that delays showing the UI
        auth.loginWithCode(route.query.code, window.location.origin + basePath + '/staff/login')
            .then(() => {
                if (!scopes.value.some((scope) => ScopeValues.includes(scope))) {
                    console.log('throwing User does not have required permissions', scopes, ScopeValues);
                    throw new Error('You do not have the required permissions to access this application.');
                }
                userType.value = 'staff';
                router.push('/staff/home');
            })
            .catch((err) => {
                auth.logout();
                error.value = err.message;
            })
            .finally(() => {
                signInInProgress.value = false;
            });
    } else {
        window.location.href = createIltAuthUrl();
    }
});

function createIltAuthUrl() {
    const basePath = (process.env.VITE_BASE_PATH || '').replace(/\/$/, '');
    return auth.createIltAuthUrl(window.location.origin + basePath + '/staff/login');
}
</script>
